import { initializeApp } from 'firebase/app'
import { getDatabase, Database } from 'firebase/database'
const firebaseConfig = {
  apiKey: 'AIzaSyCFKvWQmMcCl9rkhCERDc1zD0OxcH42pGQ',
  authDomain: 'artwork-tracker-2bdaa.firebaseapp.com',
  databaseURL:
    'https://artwork-tracker-2bdaa-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'artwork-tracker-2bdaa',
  storageBucket: 'artwork-tracker-2bdaa.firebasestorage.app',
  messagingSenderId: '712169372144',
  appId: '1:712169372144:web:0f89b40c8ea3a5fc730535',
}
let db: Database
try {
  const app = initializeApp(firebaseConfig)
  db = getDatabase(app)
} catch (error) {
  console.error('Firebase initialization error:', error)
  throw error
}
export { db }
